module.exports = __webpack_public_path__ + "img/1481102961.2163b11b.jpg";